import { CookieConsents } from './types';
const encodeCookieConsentsData = (consents) => {
    return JSON.stringify(CookieConsents.encode(consents));
};
export { encodeCookieConsentsData };
